import o from "./getBoundingClientRect.js";
function e(t) {
  var i = o(t), h = t.offsetWidth, f = t.offsetHeight;
  return Math.abs(i.width - h) <= 1 && (h = i.width), Math.abs(i.height - f) <= 1 && (f = i.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: h,
    height: f
  };
}
export {
  e as default
};
